import { FC } from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import TableViewIcon from '@mui/icons-material/TableView';
import PublicIcon from "@mui/icons-material/Public";
import BallotIcon from '@mui/icons-material/Ballot';
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import ArticleIcon from "@mui/icons-material/Article";
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DownloadIcon from '@mui/icons-material/Download';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TocIcon from '@mui/icons-material/Toc';
import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import CalculateIcon from '@mui/icons-material/Calculate';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DatasetIcon from '@mui/icons-material/Dataset';
import { makeStyles } from "@material-ui/core";
import { MAX_MOBILE_WIDTH } from "../../../constants/Constants";
import EuroIcon from '@mui/icons-material/Euro';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PaidIcon from '@mui/icons-material/Paid';
import DashboardIcon from '@mui/icons-material/Dashboard';

type Title = 'Paramètrages' | 'Production' | 'Budget' | 'Reforcaste' | 'Extraction' | 'Facturation' | 'Commission' | 'Tableau de bord' | '';

const useStyles = makeStyles(theme => ({
    iconSize: {
        marginTop: -2,
        marginRight: 3,
        fontSize: '1.5rem'
    },
    [theme.breakpoints.down("xs")]: {
        iconSize: {
            marginTop: 0,
            marginRight: 1.5,
            fontSize: '1.1rem'
        }
    }
}));

interface CustomBreadcrumbsProps {
    screenWidth: number
}

const CustomBreadcrumbs: FC<CustomBreadcrumbsProps> = ({ screenWidth }) => {
    const classes = useStyles();
    const location = useLocation();
    const { pathname } = location;

    let showBreadcrumbs: boolean = true;
    let title: Title = '';
    let subTitle: string = '';
    let firstIcon;
    let secondIcon;
    switch (pathname) {
        case '/pays':
            title = 'Paramètrages';
            subTitle = 'Pays';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <PublicIcon className={classes?.iconSize} />;
            break;
        case '/business-units':
            title = 'Paramètrages';
            subTitle = 'Business units';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <BallotIcon className={classes?.iconSize} />;
            break;
        case '/clients':
            title = 'Paramètrages';
            subTitle = 'Clients';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <AssignmentIndIcon className={classes?.iconSize} />;
            break;
        case '/operations':
            title = 'Paramètrages';
            subTitle = 'Opérations';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <DynamicFormIcon className={classes?.iconSize} />;
            break;
        case '/article':
            title = 'Paramètrages';
            subTitle = 'Article';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <ArticleIcon className={classes?.iconSize} />;
            break;
        case '/tarifs':
            title = 'Paramètrages';
            subTitle = 'Tarification';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <PriceCheckIcon className={classes?.iconSize} />;
            break;
        case '/couts':
            title = 'Paramètrages';
            subTitle = 'Coûts';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <LegendToggleIcon className={classes?.iconSize} />;
            break;
        case '/Managers-operations':
            title = 'Paramètrages';
            subTitle = 'Manager Par Opération';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <ReduceCapacityIcon className={classes?.iconSize} />;
            break;
        case '/taux':
            title = 'Paramètrages';
            subTitle = 'Taux De Change';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <TrendingUpIcon className={classes?.iconSize} />;
            break;
        case '/date-verouillage':
            title = 'Paramètrages';
            subTitle = (screenWidth > MAX_MOBILE_WIDTH) ? 'Dates de verrouillage et Dates de Cloture' : 'Dates de verrouillage ...';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <InsertInvitationIcon className={classes?.iconSize} />;
            break;
        case '/date-verouillage-cloture-budget':
            title = 'Paramètrages';
            subTitle = (screenWidth > MAX_MOBILE_WIDTH) ? 'Date de verrouillage et clôture Budget' : 'Dates de verrouillage ...';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <CalendarMonthIcon className={classes?.iconSize} />;
            break;
        case '/date-verouillage-cloture-reforecast':
            title = 'Paramètrages';
            subTitle = (screenWidth > MAX_MOBILE_WIDTH) ? 'Date de verrouillage et clôture reforecast' : 'Dates de verrouillage ...';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <DateRangeIcon className={classes?.iconSize} />;
            break;
        case '/secteur-act':
            title = 'Paramètrages';
            subTitle = 'Secteurs d’activités';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <AccountBalanceWalletIcon className={classes?.iconSize} />;
            break;
        case '/user':
            title = 'Paramètrages';
            subTitle = 'Utilisateur';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <ManageAccountsIcon className={classes?.iconSize} />;
            break;
        case '/account':
            title = 'Paramètrages';
            subTitle = 'Mon Profil';
            firstIcon = <SettingsIcon className={classes?.iconSize} />;
            secondIcon = <ManageAccountsIcon className={classes?.iconSize} />;
            break;
        case '/saisie-agent':
            title = 'Production';
            subTitle = 'Saisie Manager';
            firstIcon = <QrCodeIcon className={classes?.iconSize} />;
            secondIcon = <AppRegistrationIcon className={classes?.iconSize} />;
            break;
        case '/budget-client':
            title = 'Budget';
            subTitle = 'Budget';
            firstIcon = <PaidIcon className={classes?.iconSize} />;
            secondIcon = <ListAltIcon className={classes?.iconSize} />;
            break;
        case '/reforecast':
            title = 'Reforcaste';
            subTitle = 'Reforcaste';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <TocIcon className={classes?.iconSize} />;
            break;
        case '/extraction-budget':
            title = 'Budget';
            subTitle = 'Extraction Réalisé vs Budget';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <DatasetIcon className={classes?.iconSize} />;
            break;
        case '/import-budget':
            title = 'Budget';
            subTitle = 'Import Budget';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <DatasetIcon className={classes?.iconSize} />;
            break;
        case '/extraction-reforecast':
            title = 'Budget';
            subTitle = 'Extraction Reforecast';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <DownloadForOfflineIcon className={classes?.iconSize} />;
            break;
        case '/extraction-consolidation-reforcast':
            title = 'Reforcaste';
            subTitle = 'Extraction Reforcast Consolider par opération';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <DownloadForOfflineIcon className={classes?.iconSize} />;
            break;
        case '/import-reforcast':
            title = 'Reforcaste';
            subTitle = 'Import Reforcaste';
            firstIcon = <CurrencyExchangeIcon className={classes?.iconSize} />;
            secondIcon = <DatasetIcon className={classes?.iconSize} />;
            break;
        case '/extraction-saisie':
            title = 'Extraction';
            subTitle = 'Saisie';
            firstIcon = <DataThresholdingIcon className={classes?.iconSize} />;
            secondIcon = <AlignVerticalCenterIcon className={classes?.iconSize} />;
            break;
        case '/rentabilite':
            title = 'Extraction';
            subTitle = 'Rentabilité';
            firstIcon = <DataThresholdingIcon className={classes?.iconSize} />;
            secondIcon = <AlignHorizontalRightIcon className={classes?.iconSize} />;
            break;
        case '/generate-facture':
            title = 'Facturation';
            subTitle = 'Générer Facture';
            firstIcon = <TableViewIcon className={classes?.iconSize} />;
            secondIcon = <CalculateIcon className={classes?.iconSize} />;
            break;
        case '/commission':
            title = 'Commission';
            subTitle = 'Commerciaux - DRC';
            firstIcon = <EuroIcon className={classes?.iconSize} />;
            secondIcon = <SupportAgentIcon className={classes?.iconSize} />;
            break;
        case '/facturepro':
            title = 'Facturation';
            subTitle = 'Facture Proforma';
            firstIcon = <TableViewIcon className={classes?.iconSize} />;
            secondIcon = <ReceiptLongIcon className={classes?.iconSize} />;
            break;
        case '/extraction-commission':
            title = 'Commission';
            subTitle = 'Extraction commission des commerciaux';
            firstIcon = <TableViewIcon className={classes?.iconSize} />;
            secondIcon = <DownloadIcon className={classes?.iconSize} />;
            break;
        case '/tableau-de-bord':
            title = 'Facturation';
            subTitle = 'Tableau de bord';
            firstIcon = <TableViewIcon className={classes?.iconSize} />;
            secondIcon = <DashboardIcon className={classes?.iconSize} />;
            break;
        default:
            showBreadcrumbs = false;
            break;
    }

    if (!showBreadcrumbs) {
        return null;
    }

    return (
        <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff", ml: { xs: 1, sm: 3 } }}>
            <Link
                underline="hover"
                sx={{
                    display: "flex",
                    alignItems: "start",
                    fontWeight: "bold",
                    fontSize: { xs: 11, sm: 14 }
                }}
                color="inherit"
                href="#"
            >
                {firstIcon}
                {title}
            </Link>
            <Typography sx={{ display: "flex", alignItems: "start", fontSize: { xs: 11, sm: 14 } }}>
                {secondIcon}
                {subTitle}
            </Typography>
        </Breadcrumbs>
    );
};

export default CustomBreadcrumbs;